import { requireNativeModule } from "expo-modules-core";

/**
 * A process-wide ownership lease for one logical database.
 *
 * Native binds the lease's lifetime to this object: `release()` after a confirmed
 * engine close, garbage collection of this object, the JavaScript runtime being
 * destroyed (a reload), or process death all release the OS lock. JavaScript can
 * therefore never leave a lock behind that nothing living owns.
 */
export interface DatabaseLease {
  release(): void;
}

// Missing native support must fail closed; an OTA cannot fall back to file deletion.
interface Lifecycle {
  acquire(root: string, name: string): DatabaseLease;
  allocate(root: string): string;
  compareAndSwap(root: string, previous: string | null, next: string): void;
  read(root: string): string | null;
  seal(root: string, path: string): void;
}

// Resolve lazily: importing the engine on web/Jest does not load a native module.
export const databaseLifecycle: Lifecycle = {
  acquire: (...args) =>
    requireNativeModule<Lifecycle>("HaniverseDatabaseLifecycle").acquire(...args),
  allocate: (...args) =>
    requireNativeModule<Lifecycle>("HaniverseDatabaseLifecycle").allocate(...args),
  compareAndSwap: (...args) =>
    requireNativeModule<Lifecycle>("HaniverseDatabaseLifecycle").compareAndSwap(...args),
  read: (...args) => requireNativeModule<Lifecycle>("HaniverseDatabaseLifecycle").read(...args),
  seal: (...args) => requireNativeModule<Lifecycle>("HaniverseDatabaseLifecycle").seal(...args),
};
